import { FlightContainer as FlightContainerComponent } from './flightContainer'
import { ReactNode } from 'react'

interface FlightContainerProps {
    children: ReactNode
}

export const FlightContainer = ({ children }: FlightContainerProps) => {
    return <FlightContainerComponent>{children}</FlightContainerComponent>
}
